(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('ramda'), require('ramda-adjunct')) :
  typeof define === 'function' && define.amd ? define(['exports', 'ramda', 'ramda-adjunct'], factory) :
  (global = global || self, factory(global['functional-game-utils'] = {}, global.ramda, global['ramda-adjunct']));
}(this, function (exports, ramda, ramdaAdjunct) { 'use strict';

  var aFunction = function (it) {
    if (typeof it != 'function') {
      throw TypeError(String(it) + ' is not a function');
    } return it;
  };

  // optional / simple context binding
  var bindContext = function (fn, that, length) {
    aFunction(fn);
    if (that === undefined) return fn;
    switch (length) {
      case 0: return function () {
        return fn.call(that);
      };
      case 1: return function (a) {
        return fn.call(that, a);
      };
      case 2: return function (a, b) {
        return fn.call(that, a, b);
      };
      case 3: return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
    }
    return function (/* ...args */) {
      return fn.apply(that, arguments);
    };
  };

  var fails = function (exec) {
    try {
      return !!exec();
    } catch (error) {
      return true;
    }
  };

  var toString = {}.toString;

  var classofRaw = function (it) {
    return toString.call(it).slice(8, -1);
  };

  // fallback for non-array-like ES3 and non-enumerable old V8 strings


  var split = ''.split;

  var indexedObject = fails(function () {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins
    return !Object('z').propertyIsEnumerable(0);
  }) ? function (it) {
    return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
  } : Object;

  // `RequireObjectCoercible` abstract operation
  // https://tc39.github.io/ecma262/#sec-requireobjectcoercible
  var requireObjectCoercible = function (it) {
    if (it == undefined) throw TypeError("Can't call method on " + it);
    return it;
  };

  // `ToObject` abstract operation
  // https://tc39.github.io/ecma262/#sec-toobject
  var toObject = function (argument) {
    return Object(requireObjectCoercible(argument));
  };

  var ceil = Math.ceil;
  var floor = Math.floor;

  // `ToInteger` abstract operation
  // https://tc39.github.io/ecma262/#sec-tointeger
  var toInteger = function (argument) {
    return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
  };

  var min = Math.min;

  // `ToLength` abstract operation
  // https://tc39.github.io/ecma262/#sec-tolength
  var toLength = function (argument) {
    return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
  };

  var isObject = function (it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
  };

  // `IsArray` abstract operation
  // https://tc39.github.io/ecma262/#sec-isarray
  var isArray = Array.isArray || function isArray(arg) {
    return classofRaw(arg) == 'Array';
  };

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
  var global = typeof window == 'object' && window && window.Math == Math ? window
    : typeof self == 'object' && self && self.Math == Math ? self
    // eslint-disable-next-line no-new-func
    : Function('return this')();

  // Thank's IE8 for his funny defineProperty
  var descriptors = !fails(function () {
    return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
  });

  var document = global.document;
  // typeof document.createElement is 'object' in old IE
  var exist = isObject(document) && isObject(document.createElement);

  var documentCreateElement = function (it) {
    return exist ? document.createElement(it) : {};
  };

  // Thank's IE8 for his funny defineProperty
  var ie8DomDefine = !descriptors && !fails(function () {
    return Object.defineProperty(documentCreateElement('div'), 'a', {
      get: function () { return 7; }
    }).a != 7;
  });

  var anObject = function (it) {
    if (!isObject(it)) {
      throw TypeError(String(it) + ' is not an object');
    } return it;
  };

  // 7.1.1 ToPrimitive(input [, PreferredType])

  // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string
  var toPrimitive = function (it, S) {
    if (!isObject(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
  };

  var nativeDefineProperty = Object.defineProperty;

  var f = descriptors ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPrimitive(P, true);
    anObject(Attributes);
    if (ie8DomDefine) try {
      return nativeDefineProperty(O, P, Attributes);
    } catch (error) { /* empty */ }
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
  };

  var objectDefineProperty = {
  	f: f
  };

  var createPropertyDescriptor = function (bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };

  var hide = descriptors ? function (object, key, value) {
    return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };

  var setGlobal = function (key, value) {
    try {
      hide(global, key, value);
    } catch (error) {
      global[key] = value;
    } return value;
  };

  var shared = createCommonjsModule(function (module) {
  var SHARED = '__core-js_shared__';
  var store = global[SHARED] || setGlobal(SHARED, {});

  (module.exports = function (key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
  })('versions', []).push({
    version: '3.0.1',
    mode: 'global',
    copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
  });
  });

  var id = 0;
  var postfix = Math.random();

  var uid = function (key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + postfix).toString(36));
  };

  // Chrome 38 Symbol has incorrect toString conversion
  var nativeSymbol = !fails(function () {
    // eslint-disable-next-line no-undef
    return !String(Symbol());
  });

  var store = shared('wks');

  var Symbol$1 = global.Symbol;


  var wellKnownSymbol = function (name) {
    return store[name] || (store[name] = nativeSymbol && Symbol$1[name]
      || (nativeSymbol ? Symbol$1 : uid)('Symbol.' + name));
  };

  var SPECIES = wellKnownSymbol('species');

  // `ArraySpeciesCreate` abstract operation
  // https://tc39.github.io/ecma262/#sec-arrayspeciescreate
  var arraySpeciesCreate = function (originalArray, length) {
    var C;
    if (isArray(originalArray)) {
      C = originalArray.constructor;
      // cross-realm fallback
      if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
      else if (isObject(C)) {
        C = C[SPECIES];
        if (C === null) C = undefined;
      }
    } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
  };

  // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
  // 0 -> Array#forEach
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  // 1 -> Array#map
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  // 2 -> Array#filter
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  // 3 -> Array#some
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  // 4 -> Array#every
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  // 5 -> Array#find
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  // 6 -> Array#findIndex
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  var arrayMethods = function (TYPE, specificCreate) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    var create = specificCreate || arraySpeciesCreate;
    return function ($this, callbackfn, that) {
      var O = toObject($this);
      var self = indexedObject(O);
      var boundFunction = bindContext(callbackfn, that, 3);
      var length = toLength(self.length);
      var index = 0;
      var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
      var value, result;
      for (;length > index; index++) if (NO_HOLES || index in self) {
        value = self[index];
        result = boundFunction(value, index, O);
        if (TYPE) {
          if (IS_MAP) target[index] = result; // map
          else if (result) switch (TYPE) {
            case 3: return true;              // some
            case 5: return value;             // find
            case 6: return index;             // findIndex
            case 2: target.push(value);       // filter
          } else if (IS_EVERY) return false;  // every
        }
      }
      return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
  };

  var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
  var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

  // Nashorn ~ JDK8 bug
  var NASHORN_BUG = nativeGetOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

  var f$1 = NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = nativeGetOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
  } : nativePropertyIsEnumerable;

  var objectPropertyIsEnumerable = {
  	f: f$1
  };

  // toObject with fallback for non-array-like ES3 strings



  var toIndexedObject = function (it) {
    return indexedObject(requireObjectCoercible(it));
  };

  var hasOwnProperty = {}.hasOwnProperty;

  var has = function (it, key) {
    return hasOwnProperty.call(it, key);
  };

  var nativeGetOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

  var f$2 = descriptors ? nativeGetOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = toIndexedObject(O);
    P = toPrimitive(P, true);
    if (ie8DomDefine) try {
      return nativeGetOwnPropertyDescriptor$1(O, P);
    } catch (error) { /* empty */ }
    if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
  };

  var objectGetOwnPropertyDescriptor = {
  	f: f$2
  };

  var functionToString = shared('native-function-to-string', Function.toString);

  var WeakMap = global.WeakMap;

  var nativeWeakMap = typeof WeakMap === 'function' && /native code/.test(functionToString.call(WeakMap));

  var shared$1 = shared('keys');


  var sharedKey = function (key) {
    return shared$1[key] || (shared$1[key] = uid(key));
  };

  var hiddenKeys = {};

  var WeakMap$1 = global.WeakMap;
  var set, get, has$1;

  var enforce = function (it) {
    return has$1(it) ? get(it) : set(it, {});
  };

  var getterFor = function (TYPE) {
    return function (it) {
      var state;
      if (!isObject(it) || (state = get(it)).type !== TYPE) {
        throw TypeError('Incompatible receiver, ' + TYPE + ' required');
      } return state;
    };
  };

  if (nativeWeakMap) {
    var store$1 = new WeakMap$1();
    var wmget = store$1.get;
    var wmhas = store$1.has;
    var wmset = store$1.set;
    set = function (it, metadata) {
      wmset.call(store$1, it, metadata);
      return metadata;
    };
    get = function (it) {
      return wmget.call(store$1, it) || {};
    };
    has$1 = function (it) {
      return wmhas.call(store$1, it);
    };
  } else {
    var STATE = sharedKey('state');
    hiddenKeys[STATE] = true;
    set = function (it, metadata) {
      hide(it, STATE, metadata);
      return metadata;
    };
    get = function (it) {
      return has(it, STATE) ? it[STATE] : {};
    };
    has$1 = function (it) {
      return has(it, STATE);
    };
  }

  var internalState = {
    set: set,
    get: get,
    has: has$1,
    enforce: enforce,
    getterFor: getterFor
  };

  var redefine = createCommonjsModule(function (module) {
  var getInternalState = internalState.get;
  var enforceInternalState = internalState.enforce;
  var TEMPLATE = String(functionToString).split('toString');

  shared('inspectSource', function (it) {
    return functionToString.call(it);
  });

  (module.exports = function (O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;
    if (typeof value == 'function') {
      if (typeof key == 'string' && !has(value, 'name')) hide(value, 'name', key);
      enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
    if (O === global) {
      if (simple) O[key] = value;
      else setGlobal(key, value);
      return;
    } else if (!unsafe) {
      delete O[key];
    } else if (!noTargetGet && O[key]) {
      simple = true;
    }
    if (simple) O[key] = value;
    else hide(O, key, value);
  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  })(Function.prototype, 'toString', function toString() {
    return typeof this == 'function' && getInternalState(this).source || functionToString.call(this);
  });
  });

  var max = Math.max;
  var min$1 = Math.min;

  // Helper for a popular repeating case of the spec:
  // Let integer be ? ToInteger(index).
  // If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
  var toAbsoluteIndex = function (index, length) {
    var integer = toInteger(index);
    return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
  };

  // `Array.prototype.{ indexOf, includes }` methods implementation
  // false -> Array#indexOf
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  // true  -> Array#includes
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  var arrayIncludes = function (IS_INCLUDES) {
    return function ($this, el, fromIndex) {
      var O = toIndexedObject($this);
      var length = toLength(O.length);
      var index = toAbsoluteIndex(fromIndex, length);
      var value;
      // Array#includes uses SameValueZero equality algorithm
      // eslint-disable-next-line no-self-compare
      if (IS_INCLUDES && el != el) while (length > index) {
        value = O[index++];
        // eslint-disable-next-line no-self-compare
        if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
      } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      } return !IS_INCLUDES && -1;
    };
  };

  var arrayIndexOf = arrayIncludes(false);


  var objectKeysInternal = function (object, names) {
    var O = toIndexedObject(object);
    var i = 0;
    var result = [];
    var key;
    for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while (names.length > i) if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
    return result;
  };

  // IE8- don't enum bug keys
  var enumBugKeys = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
  ];

  // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

  var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');

  var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return objectKeysInternal(O, hiddenKeys$1);
  };

  var objectGetOwnPropertyNames = {
  	f: f$3
  };

  var f$4 = Object.getOwnPropertySymbols;

  var objectGetOwnPropertySymbols = {
  	f: f$4
  };

  var Reflect$1 = global.Reflect;

  // all object keys, includes non-enumerable and symbols
  var ownKeys = Reflect$1 && Reflect$1.ownKeys || function ownKeys(it) {
    var keys = objectGetOwnPropertyNames.f(anObject(it));
    var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
    return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
  };

  var copyConstructorProperties = function (target, source) {
    var keys = ownKeys(source);
    var defineProperty = objectDefineProperty.f;
    var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  };

  var replacement = /#|\.prototype\./;

  var isForced = function (feature, detection) {
    var value = data[normalize(feature)];
    return value == POLYFILL ? true
      : value == NATIVE ? false
      : typeof detection == 'function' ? fails(detection)
      : !!detection;
  };

  var normalize = isForced.normalize = function (string) {
    return String(string).replace(replacement, '.').toLowerCase();
  };

  var data = isForced.data = {};
  var NATIVE = isForced.NATIVE = 'N';
  var POLYFILL = isForced.POLYFILL = 'P';

  var isForced_1 = isForced;

  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;






  /*
    options.target      - name of the target object
    options.global      - target is the global object
    options.stat        - export as static methods of target
    options.proto       - export as prototype methods of target
    options.real        - real prototype method for the `pure` version
    options.forced      - export even if the native feature is available
    options.bind        - bind methods to the target, required for the `pure` version
    options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
    options.unsafe      - use the simple assignment of property instead of delete + defineProperty
    options.sham        - add a flag to not completely full polyfills
    options.enumerable  - export as enumerable property
    options.noTargetGet - prevent calling a getter on target
  */
  var _export = function (options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) {
      target = global;
    } else if (STATIC) {
      target = global[TARGET] || setGlobal(TARGET, {});
    } else {
      target = (global[TARGET] || {}).prototype;
    }
    if (target) for (key in source) {
      sourceProperty = source[key];
      if (options.noTargetGet) {
        descriptor = getOwnPropertyDescriptor(target, key);
        targetProperty = descriptor && descriptor.value;
      } else targetProperty = target[key];
      FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
      // contained in target
      if (!FORCED && targetProperty !== undefined) {
        if (typeof sourceProperty === typeof targetProperty) continue;
        copyConstructorProperties(sourceProperty, targetProperty);
      }
      // add a flag to not completely full polyfills
      if (options.sham || (targetProperty && targetProperty.sham)) {
        hide(sourceProperty, 'sham', true);
      }
      // extend global
      redefine(target, key, sourceProperty, options);
    }
  };

  // 19.1.2.14 / 15.2.3.14 Object.keys(O)



  var objectKeys = Object.keys || function keys(O) {
    return objectKeysInternal(O, enumBugKeys);
  };

  var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var keys = objectKeys(Properties);
    var length = keys.length;
    var i = 0;
    var key;
    while (length > i) objectDefineProperty.f(O, key = keys[i++], Properties[key]);
    return O;
  };

  var document$1 = global.document;

  var html = document$1 && document$1.documentElement;

  // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])





  var IE_PROTO = sharedKey('IE_PROTO');
  var PROTOTYPE = 'prototype';
  var Empty = function () { /* empty */ };

  // Create object with fake `null` prototype: use iframe Object with cleared prototype
  var createDict = function () {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = documentCreateElement('iframe');
    var length = enumBugKeys.length;
    var lt = '<';
    var script = 'script';
    var gt = '>';
    var js = 'java' + script + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    html.appendChild(iframe);
    iframe.src = String(js);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
    iframeDocument.close();
    createDict = iframeDocument.F;
    while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
    return createDict();
  };

  var objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
      Empty[PROTOTYPE] = anObject(O);
      result = new Empty();
      Empty[PROTOTYPE] = null;
      // add "__proto__" for Object.getPrototypeOf polyfill
      result[IE_PROTO] = O;
    } else result = createDict();
    return Properties === undefined ? result : objectDefineProperties(result, Properties);
  };

  hiddenKeys[IE_PROTO] = true;

  var UNSCOPABLES = wellKnownSymbol('unscopables');


  var ArrayPrototype = Array.prototype;

  // Array.prototype[@@unscopables]
  // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
  if (ArrayPrototype[UNSCOPABLES] == undefined) {
    hide(ArrayPrototype, UNSCOPABLES, objectCreate(null));
  }

  // add a key to Array.prototype[@@unscopables]
  var addToUnscopables = function (key) {
    ArrayPrototype[UNSCOPABLES][key] = true;
  };

  var internalFind = arrayMethods(5);
  var FIND = 'find';
  var SKIPS_HOLES = true;

  // Shouldn't skip holes
  if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  _export({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
    find: function find(callbackfn /* , that = undefined */) {
      return internalFind(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });

  // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
  addToUnscopables(FIND);

  var sloppyArrayMethod = function (METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !method || !fails(function () {
      // eslint-disable-next-line no-useless-call,no-throw-literal
      method.call(null, argument || function () { throw 1; }, 1);
    });
  };

  var nativeForEach = [].forEach;
  var internalForEach = arrayMethods(0);

  var SLOPPY_METHOD = sloppyArrayMethod('forEach');

  // `Array.prototype.forEach` method implementation
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  var arrayForEach = SLOPPY_METHOD ? function forEach(callbackfn /* , thisArg */) {
    return internalForEach(this, callbackfn, arguments[1]);
  } : nativeForEach;

  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  _export({ target: 'Array', proto: true, forced: [].forEach != arrayForEach }, { forEach: arrayForEach });

  // iterable DOM collections
  // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
  var domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  };

  for (var COLLECTION_NAME in domIterables) {
    var Collection = global[COLLECTION_NAME];
    var CollectionPrototype = Collection && Collection.prototype;
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype && CollectionPrototype.forEach !== arrayForEach) try {
      hide(CollectionPrototype, 'forEach', arrayForEach);
    } catch (error) {
      CollectionPrototype.forEach = arrayForEach;
    }
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct.bind();
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }

  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return _assertThisInitialized(self);
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  /**
   * @module Assert
   */

  /**
   * @description A special error that indicates an assertion has failed.
   *
   * @extends Error
   */
  var AssertionError = /*#__PURE__*/function (_Error) {
    _inherits(AssertionError, _Error);

    /**
     * @param {string} message - The message containing more information about a given AssertionError.
     */
    function AssertionError(message) {
      _classCallCheck(this, AssertionError);

      return _possibleConstructorReturn(this, _getPrototypeOf(AssertionError).call(this, "AssertionError: ".concat(message)));
    }

    return AssertionError;
  }(_wrapNativeSuper(Error));
  /**
   * @description If the assertion is truthy then nothing will happen. Otherwise, this function throws
   * an {@link AssertionError} with the provided message if the assertion is falsy.
   *
   * @example
   * function example(param) {
   *   assert(typeof param === 'string', 'Param must be of type string!');
   * }
   *
   * @param {boolean} assertion
   * @param {string} message
   */


  var assert = function assert(assertion, message) {
    if (!assertion) {
      throw new AssertionError(message);
    }
  };

  /**
   * @module Matrix
   */
  /**
   * @description Checks if the given matrix includes the given
   * location
   *
   * @param {Object[][]} matrix
   * @param {Location} location
   *
   * @returns {Boolean} true if the given location exists within
   * the matrix.
   */

  var isLocationInBounds = ramda.curry(function (matrix, _ref) {
    var row = _ref.row,
        col = _ref.col;
    return Boolean(row < matrix.length && row >= 0 && matrix[row] && col < matrix[row].length && col >= 0);
  });
  /**
   * @description Gets the cell's value at the specified location
   * from the matrix.
   *
   * @param {Object[][]} matrix
   * @param {Location} location
   *
   * @throws {AssertionError} the target location is not contained
   * in the provided matrix's bounds
   * @returns {Object} the retrieved object
   */

  var getLocation = ramda.curry(function (matrix, location) {
    assert(isLocationInBounds(matrix, location), "Location: ".concat(JSON.stringify(location), " isn't in bounds!"));
    return matrix[location.row][location.col];
  });
  /**
   * @description Check if two locations are equal. Determined by
   * a comparison of row and col values of each location.
   *
   * @param {Location} a
   * @param {Location} b
   *
   * @returns {boolean} true if both locations are equal
   */

  var compareLocations = ramda.curry(function (a, b) {
    return a.row === b.row && a.col === b.col;
  });
  /**
   * @description Calculates the Manhattan Distance between two
   * provided locations
   *
   * @param {Location} a
   * @param {Location} b
   *
   * @returns {number} the integer value of the calculated distance
   */

  var manhattanDistance = ramda.curry(function (a, b) {
    return Math.abs(a.row - b.row) + Math.abs(a.col - b.col);
  });

  /**
   * @description Creates an array on a specified length and filled with a specified value.
   *
   * @function
   * @param {number} length - The length of the array to be filled.
   * @param {number} value - What value each index of the array will be filled with.
   * @returns {Object[]} Newly created array of values.
   */

  var fillArray = ramda.curry(function (length, value) {
    return ramda.times(function () {
      return ramda.clone(value);
    }, length);
  });
  /**
   * @description Creates an array of the specified length and filled with 0s.
   *
   * @param {number} length - The length of the array to be filled.
   * @returns {number[]} Newly created array of 0s.
   */

  var initArray = function initArray(length) {
    return fillArray(length, 0);
  };
  /**
   * @description A function used to construct the value of a given array index.
   *
   * @callback ArrayConstructor
   * @param {number} index - The index of the constructed value.
   */

  /**
   * @description Creates an array of the specified length where each index is filled with the
   * result of running the constructor function.
   *
   * @param {ArrayConstructor} constructor - The function used to construct each value of the array.
   * @param {number} length - The length of the array to be filled. Must be a positive number not including zero.
   * @throws {AssertionError} - Will throw an error if constructor isn't a function.
   * @throws {AssertionError} - Will throw an error if length isn't a positive number not including zero.
   * @returns {Object[]} Newly created array of the constructed values.
   */


  var constructArray = ramda.curry(function (constructor, length) {
    assert(ramdaAdjunct.isFunction(constructor), "Constructor argument should be a function!");
    assert(ramdaAdjunct.isPositive(length), "Length argument should be a positive number!");
    return ramda.pipe(initArray, // Ignore the array value, and total original array.
    // These values are all generated by initArray and the user doesn't care.
    ramdaAdjunct.mapIndexed(function (_, index) {
      return constructor(index);
    }))(length);
  });
  /**
   * @description Does the provided array contain the location provided.
   *
   * @method
   * @param {Object[]} array - The array to be searched.
   * @param {Location} location - The location to ge searched for.
   * @returns {boolean} True if the location is present in the array.
   */

  var containsLocation = ramda.curry(function (array, location) {
    return Boolean(array.find(function (value) {
      return compareLocations(value, location);
    }));
  });
  var findBestMatch = ramda.curry(function (evaluator, determineBetterFit, array) {
    var currentBest;
    array.forEach(function (value, index) {
      var evaluated = evaluator(value);

      if (currentBest === undefined) {
        currentBest = index;
      }

      if (determineBetterFit(evaluator(array[currentBest]), evaluated)) {
        currentBest = index;
      }
    });
    return currentBest;
  });

  /**
   * @module Matrix
   */
  /**
   * @description Creates a matrix of the specified dimensions filled
   * with the provided value at every location.
   *
   * @param {Dimensions} dimensions - width and height of this matrix
   * @param {Object} value - any value to fill the matrix with
   *
   * @returns {Object[][]} the newly created array
   */

  var fillMatrix = ramda.curry(function (_ref, value) {
    var width = _ref.width,
        height = _ref.height;
    return ramda.pipe(fillArray(width), fillArray(height))(value);
  });

  /**
   * @module Matrix
   */
  /**
   * @description Creates a matrix of the specified dimensions
   * with all cells set to a value of 0.
   *
   * @param {Dimensions} dimensions
   *
   * @returns {number[][]} the initialized matrix
   */

  var initMatrix = function initMatrix(dimensions) {
    return fillMatrix(dimensions)(0);
  };

  var SPECIES$1 = wellKnownSymbol('species');

  var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
    return !fails(function () {
      var array = [];
      var constructor = array.constructor = {};
      constructor[SPECIES$1] = function () {
        return { foo: 1 };
      };
      return array[METHOD_NAME](Boolean).foo !== 1;
    });
  };

  var internalMap = arrayMethods(1);

  var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  // with adding support of @@species
  _export({ target: 'Array', proto: true, forced: !SPECIES_SUPPORT }, {
    map: function map(callbackfn /* , thisArg */) {
      return internalMap(this, callbackfn, arguments[1]);
    }
  });

  /**
   * Takes in the value, location, and matrix being mapped
   * and returns a new object.
   *
   * @callback CellMapper
   *
   * @param {Object} value
   * @param {Location} location
   * @param {Object[][]} matrix
   *
   * @returns {Object}
   */

  /**
   * @description Maps over the provided matrix with the provided
   * callback and returns a new matrix.
   *
   * @param {CellMapper} callback
   * @param {Object[][]} matrix
   *
   * @returns {Object[][]} the newly mapped matrix
   */

  var mapMatrix = ramda.curry(function (cb, matrix) {
    return matrix.map(function (array, row) {
      return array.map(function (value, col) {
        return cb(value, {
          row: row,
          col: col
        }, matrix);
      });
    });
  });

  /**
   * @module Matrix
   */
  /**
   * @description Set the cell of the matrix at the location to a value.
   *
   * @param {Location} location
   * @param {Object} value
   * @param {Object[][]} matrix
   *
   * @returns {Object[][]} matrix with the location updated
   */

  var updateMatrix = ramda.curry(function (_ref, value, matrix) {
    var row = _ref.row,
        col = _ref.col;
    return ramda.update(row, ramda.update(col, value, matrix[row]), matrix);
  });

  /**
   * @module Matrix
   */
  var getLocationFromDirection = ramda.curry(function (location, direction) {
    var row = location.row,
        col = location.col;

    if (direction.up) {
      row -= 1;
    } else if (direction.down) {
      row += 1;
    }

    if (direction.left) {
      col -= 1;
    } else if (direction.right) {
      col += 1;
    }

    return {
      row: row,
      col: col
    };
  });
  /**
   * @description Get all the neighboring locations of the provided location from
   * the provided matrix that are in bounds.
   *
   * @param {function} - getDirections - this function should return a
   * {Connections} object defining how matrix cells are connected.
   * @param {Object[][]} - matrix - the matrix to be checked
   * @param {Location} - location - location in the matrix whose neighbors
   * should be returned.
   *
   * @returns {Location[]} array of all valid neighboring locations
   */

  var getNeighbors = ramda.curry(function (getDirections, matrix, location) {
    var isLocationInBoundsWithMatrix = isLocationInBounds(matrix);

    if (!isLocationInBoundsWithMatrix(location)) {
      // Location out of bounds has no neighbors
      return [];
    }

    var getLocationFromDirectionWithLocation = getLocationFromDirection(location);
    return ramda.pipe(ramda.map(getLocationFromDirectionWithLocation), ramda.filter(isLocationInBoundsWithMatrix))(getDirections(getLocation(matrix, location)));
  });

  var internalFilter = arrayMethods(2);

  var SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('filter');

  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  // with adding support of @@species
  _export({ target: 'Array', proto: true, forced: !SPECIES_SUPPORT$1 }, {
    filter: function filter(callbackfn /* , thisArg */) {
      return internalFilter(this, callbackfn, arguments[1]);
    }
  });

  /**
   * @module Matrix
   */
  /**
   * @description Get a row of the provided matrix
   *
   * @param {Object[][]} matrix
   * @param {number} rowIndex - row index to be gotten
   *
   * @returns {Object[]} a single row of the matrix
   */

  var getRow = ramda.curry(function (matrix, rowIndex) {
    return matrix[rowIndex];
  });

  var isEntireArrayUndefined = function isEntireArrayUndefined(array) {
    return ramda.all(ramda.equals(undefined), array);
  };
  /**
   * @description Get a column of the provided matrix
   *
   * @param {Object[][]} matrix
   * @param {number} colIndex - column index to be gotten
   *
   * @returns {Object[]} a single column of the matrix
   */


  var getCol = ramda.curry(function (matrix, colIndex) {
    var col = ramda.map(function (row) {
      return row[colIndex];
    }, matrix);
    return isEntireArrayUndefined(col) ? undefined : col;
  });
  /**
   * @description Get the dimensions objet describing the
   * provided matrix.
   *
   * @param {Object[][]} matrix
   *
   * @returns {Dimensions} width and height of the provided matrix
   */

  var getDimensions = function getDimensions(matrix) {
    return {
      height: getCol(matrix, 0).length,
      width: getRow(matrix, 0).length
    };
  };

  // the docs, so I've hardcoded them into the enum's
  // description.

  /**
   * Directions to rotate a matrix:
   * CLOCKWISE, COUNTER_CLOCKWISE
   *
   * @readonly
   * @enum {string}
   */

  var MATRIX_ROTATION_DIRECTIONS = {
    CLOCKWISE: "CLOCKWISE",
    COUNTER_CLOCKWISE: "COUNTER_CLOCKWISE"
  };
  /**
   * @description Rotate a matrix in the provided direction
   *
   * @param {Object} options - control how the matrix is rotated
   * @param {MATRIX_ROTATION_DIRECTIONS} options.direction - direction to rotate the matrix
   * @param {Object[][]} - matrix to be rotated
   *
   * @returns {Object[][]} newly rotated matrix
   */

  var rotateMatrix = ramda.curry(function (_ref, matrix) {
    var direction = _ref.direction;

    var _getDimensions = getDimensions(matrix),
        width = _getDimensions.width;

    switch (direction) {
      case MATRIX_ROTATION_DIRECTIONS.COUNTER_CLOCKWISE:
        return initArray(width).map(function (_, index) {
          // Grab the columns in reverse order
          var col = getCol(matrix, width - 1 - index); // We can only operate on a column that exists

          if (col) {
            return col;
          }
        }) // Filter out rows that are falsy. If a matrix's dimensions are
        // uneven, we'll have this occur when referencing a row or col
        // that does not exist.
        .filter(function (row) {
          return Boolean(row);
        });

      case MATRIX_ROTATION_DIRECTIONS.CLOCKWISE:
      default:
        return initArray(width).map(function (_, index) {
          var col = getCol(matrix, index); // We can only operate on a column that exists

          if (col) {
            return col.reverse();
          }
        }) // Filter out rows that are falsy. If a matrix's dimensions are
        // uneven, we'll have this occur when referencing a row or col
        // that does not exist.
        .filter(function (row) {
          return Boolean(row);
        });
    }
  });

  /**
   * @description Transpose (flip the columns and rows) the provided matrix.
   *
   * @param {Object[][]} matrix
   *
   * @returns {Object[][]} the transposed matrix
   */

  var transposeMatrix = ramda.curry(function (matrix) {
    var _getDimensions = getDimensions(matrix),
        width = _getDimensions.width;

    return initArray(width).map(function (_, index) {
      // Grab the columns in reverse order
      return getCol(matrix, index);
    });
  });

  // the docs, so I've hardcoded them into the enum's
  // description.

  /**
   * Directions to translate a matrix:
   * UP, DOWN, LEFT, RIGHT
   *
   * @readonly
   * @enum {string}
   */

  var MATRIX_TRANSLATE_DIRECTIONS = {
    UP: "UP",
    DOWN: "DOWN",
    LEFT: "LEFT",
    RIGHT: "RIGHT"
  };
  /**
   * @description Translate a matrix in the provided direction
   *
   * @param {Object} options - control how the matrix is translated
   * @param {boolean} [options.shouldWrap=false] - should the edge of the matrix at the end of the
   * translation be placed on the opposite side of the matrix, or should it be removed entirely
   * @param {MatrixConstructor} [options.constructFn=()=>undefined] - if wrapping is disabled, this
   * constructor function is used to create the row at the newly exposed edge of the matrix.
   * @param {MATRIX_TRANSLATE_DIRECTIONS} options.direction - direction to translate the matrix
   * @param {Object[][]} - matrix to be translated
   *
   * @returns {Object[][]} newly translated matrix
   */

  var translateMatrix = ramda.curry(function (_ref, matrix) {
    var _ref$shouldWrap = _ref.shouldWrap,
        shouldWrap = _ref$shouldWrap === void 0 ? false : _ref$shouldWrap,
        _ref$constructFn = _ref.constructFn,
        constructFn = _ref$constructFn === void 0 ? function () {
      return undefined;
    } : _ref$constructFn,
        direction = _ref.direction;

    var _getDimensions = getDimensions(matrix),
        height = _getDimensions.height,
        width = _getDimensions.width;

    switch (direction) {
      case MATRIX_TRANSLATE_DIRECTIONS.UP:
        return matrix.map(function (_, rowIndex) {
          var nextRow = getRow(matrix, rowIndex + 1); // If there is not next row, we're on the last row in our matrix

          if (!nextRow) {
            if (shouldWrap) {
              // If we should wrap, our last row should become the original first row
              return getRow(matrix, 0);
            } // If nothing else, use the provided construct function to build a new final row


            return constructArray(constructFn, width);
          }

          return nextRow;
        });

      case MATRIX_TRANSLATE_DIRECTIONS.DOWN:
        return matrix.map(function (_, rowIndex) {
          var prevRow = getRow(matrix, rowIndex - 1); // If there is not next row, we're on the first row in our matrix

          if (!prevRow) {
            if (shouldWrap) {
              // If we should wrap, our first row should become the original last row
              return getRow(matrix, height - 1);
            } // If nothing else, use the provided construct function to build a new final row


            return constructArray(constructFn, width);
          }

          return prevRow;
        });

      case MATRIX_TRANSLATE_DIRECTIONS.RIGHT:
        {
          var translatedColumns = initArray(width).map(function (_, colIndex) {
            var prevCol = getCol(matrix, colIndex - 1); // If there is not prev column, we're on the first col in our matrix

            if (!prevCol) {
              if (shouldWrap) {
                // If we should wrap, our first column should become the original last column
                return getCol(matrix, width - 1);
              } // If nothing else, use the provided construct function to build a new final column


              return constructArray(constructFn, height);
            }

            return prevCol;
          });
          return transposeMatrix(translatedColumns);
        }

      case MATRIX_TRANSLATE_DIRECTIONS.LEFT:
        {
          var _translatedColumns = initArray(width).map(function (_, colIndex) {
            var nextCol = getCol(matrix, colIndex + 1); // If there is not next column, we're on the last col in our matrix

            if (!nextCol) {
              if (shouldWrap) {
                // If we should wrap, our last column should become the original first column
                return getCol(matrix, 0);
              } // If nothing else, use the provided construct function to build a new final column


              return constructArray(constructFn, height);
            }

            return nextCol;
          });

          return transposeMatrix(_translatedColumns);
        }

      default:
        break;
    }
  });

  var createProperty = function (object, key, value) {
    var propertyKey = toPrimitive(key);
    if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
    else object[propertyKey] = value;
  };

  var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
  var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
  var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

  var IS_CONCAT_SPREADABLE_SUPPORT = !fails(function () {
    var array = [];
    array[IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
  });

  var SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport('concat');

  var isConcatSpreadable = function (O) {
    if (!isObject(O)) return false;
    var spreadable = O[IS_CONCAT_SPREADABLE];
    return spreadable !== undefined ? !!spreadable : isArray(O);
  };

  var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT$2;

  // `Array.prototype.concat` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.concat
  // with adding support of @@isConcatSpreadable and @@species
  _export({ target: 'Array', proto: true, forced: FORCED }, {
    concat: function concat(arg) { // eslint-disable-line no-unused-vars
      var O = toObject(this);
      var A = arraySpeciesCreate(O, 0);
      var n = 0;
      var i, k, length, len, E;
      for (i = -1, length = arguments.length; i < length; i++) {
        E = i === -1 ? O : arguments[i];
        if (isConcatSpreadable(E)) {
          len = toLength(E.length);
          if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
          for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
        } else {
          if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
          createProperty(A, n++, E);
        }
      }
      A.length = n;
      return A;
    }
  });

  /**
   * @description An object describing a direction. It should contain no more than 2 truthy properties.
   * @typedef {Object} Direction
   *
   * @property {boolean} up - Is a component of this direction facing up.
   * @property {boolean} down - Is a component of this direction facing down.
   * @property {boolean} left - Is a component of this direction facing left.
   * @property {boolean} right - Is a component of this direction facing right.
   */

  /**
   * @description Creates an array of directions representing the cross-shaped
   * neighbors of a cell.
   *
   * The following diagram describes the neighboring directions represented by X's.
   * | |X| |
   * -------
   * |X| |X|
   * -------
   * | |X| |
   *
   * @returns {Direction[]} Directions representing up, down, left, and right.
   */

  var getCrossDirections = function getCrossDirections() {
    return [{
      up: true
    }, {
      left: true
    }, {
      right: true
    }, {
      down: true
    }];
  };
  /**
   * @description Creates an array of directions representing the X-shaped diagonal
   * neighbors of a cell.
   *
   * The following diagram describes the neighboring directions represented by X's.
   * |X| |X|
   * -------
   * | | | |
   * -------
   * |X| |X|
   *
   * @returns {Direction[]} Directions representing upper left, upper right, lower left, and lower right.
   */


  var getDiagonalDirections = function getDiagonalDirections() {
    return [{
      up: true,
      left: true
    }, {
      up: true,
      right: true
    }, {
      down: true,
      right: true
    }, {
      down: true,
      left: true
    }];
  };
  /**
   * @description Creates an array of directions representing the all diagonal and cross-shaped
   * neighbors of a cell.
   *
   * The following diagram describes the neighboring directions represented by X's.
   * |X|X|X|
   * -------
   * |X| |X|
   * -------
   * |X|X|X|
   *
   * @returns {Direction[]} Directions representing upper left, up, upper right, right,
   * lower right, down, lower left, and left.
   */


  var getAllDirections = function getAllDirections() {
    return [].concat(_toConsumableArray(getCrossDirections()), _toConsumableArray(getDiagonalDirections()));
  };

  var isPairConnected = function isPairConnected(_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        connected = _ref2[1];

    return connected;
  };

  var buildDirection = function buildDirection(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        direction = _ref4[0];

    return _defineProperty({}, direction, true);
  };
  /**
   * @description An object describing the connections of a cell.
   * @typedef {Object} Connections
   *
   * @property {boolean} up - Is this cell connected to its upper neighbor.
   * @property {boolean} down - Is this cell connected to its lower neighbor.
   * @property {boolean} left - Is this cell connected to its left neighbor.
   * @property {boolean} right - Is this cell connected to its right neighbor.
   */

  /**
   * @description Creates an array of the directions connected to this object in a cross-shaped
   * pattern. A connection is determined by the connections object passed into this function.
   * If a connection direction is truthy then it is counted as connected.
   *
   * @param {Connections} connections - An object that describes which neighbors this cell is
   * connected to.
   * @returns {Directions[]} All directions connected to the cell.
   */


  var getConnectedDirections = ramda.pipe(ramda.pick(["up", "down", "left", "right"]), ramda.toPairs, ramda.filter(isPairConnected), ramda.map(buildDirection));

  // `Array.prototype.{ reduce, reduceRight }` methods implementation
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
  var arrayReduce = function (that, callbackfn, argumentsLength, memo, isRight) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = indexedObject(O);
    var length = toLength(O.length);
    var index = isRight ? length - 1 : 0;
    var i = isRight ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (isRight ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };

  var SLOPPY_METHOD$1 = sloppyArrayMethod('reduce');

  // `Array.prototype.reduce` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
  _export({ target: 'Array', proto: true, forced: SLOPPY_METHOD$1 }, {
    reduce: function reduce(callbackfn /* , initialValue */) {
      return arrayReduce(this, callbackfn, arguments.length, arguments[1], false);
    }
  });

  /**
   * The width and height of a matrix
   * @typedef Dimensions
   *
   * @param {number} width - How many columns are in a matrix
   * @param {number} height - How many rows are in a matrix
   */

  /**
   * Find the length of the longest row in the provided matrix.
   * @param {Object} matrix
   */

  var maxWidth = function maxWidth(matrix) {
    return matrix.reduce(function (greatest, row) {
      return row.length > greatest ? row.length : greatest;
    }, 0);
  };
  /**
   * Get the height of a matrix.
   * @param {Object} matrix
   */


  var height = function height(matrix) {
    return matrix.length;
  };

  /**
   * @module Matrix
   */
  /**
   * @callback CellComparator
   *
   * @param {Object} cell - the cell's value at the current location
   * @param {Location} location - the location being checked
   *
   * @returns {boolean} true if this cell/location satisfies the condition
   */

  /**
   * @description Search a provided matrix for the first cell that satisfies
   * the provided comparator's condition. Returns that cell's value.
   *
   * @param {CellComparator} comparator - callback to check if any given cell
   * or location should be found.
   * @param {Object[][]} matrix - matrix to be searched
   *
   * @returns {(Object|undefined)} the found value or undefined if nothing
   * matching the comparator was found.
   */

  var findValue = ramda.curry(function (comparator, matrix) {
    var found;

    for (var row = 0; row < height(matrix) && !found; row++) {
      for (var col = 0; col < maxWidth(matrix) && !found; col++) {
        if (comparator(matrix[row][col], {
          row: row,
          col: col
        })) {
          found = matrix[row][col];
        }
      }
    }

    return found;
  });
  /**
   * @description Search a provided matrix for the first cell that satisfies
   * the provided comparator's condition. Return's that cell's location.
   *
   * @param {CellComparator} comparator - callback to check if any given cell
   * or location should be found.
   * @param {Object[][]} matrix - matrix to be searched
   *
   * @returns {(Location|undefined)} the found value or undefined if nothing
   * matching the comparator was found.
   */

  var findLocation = ramda.curry(function (comparator, matrix) {
    var found = false;
    var location = {};

    for (var row = 0; row < height(matrix) && !found; row++) {
      for (var col = 0; col < maxWidth(matrix) && !found; col++) {
        if (comparator(matrix[row][col], {
          row: row,
          col: col
        })) {
          found = true;
          location = {
            row: row,
            col: col
          };
        }
      }
    }

    return found ? location : undefined;
  });
  /**
   * @description Search a provided matrix for the all cell that satisfy
   * the provided comparator's condition. Returns all matching locations.
   *
   * @param {CellComparator} comparator - callback to check if any given cell
   * or location should be found.
   * @param {Object[][]} matrix - matrix to be searched
   *
   * @returns {Location[]} array containing all matching locations in the
   * provided matrix.
   */

  var findLocations = ramda.curry(function (comparator, matrix) {
    var matches = [];

    for (var row = 0; row < height(matrix); row++) {
      for (var col = 0; col < maxWidth(matrix); col++) {
        if (comparator(matrix[row][col], {
          row: row,
          col: col
        })) {
          matches.push({
            row: row,
            col: col
          });
        }
      }
    }

    return matches;
  });

  // `RegExp.prototype.flags` getter implementation
  // https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
  var regexpFlags = function () {
    var that = anObject(this);
    var result = '';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.unicode) result += 'u';
    if (that.sticky) result += 'y';
    return result;
  };

  var nativeExec = RegExp.prototype.exec;
  // This always refers to the native implementation, because the
  // String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
  // which loads this file before patching the method.
  var nativeReplace = String.prototype.replace;

  var patchedExec = nativeExec;

  var UPDATES_LAST_INDEX_WRONG = (function () {
    var re1 = /a/;
    var re2 = /b*/g;
    nativeExec.call(re1, 'a');
    nativeExec.call(re2, 'a');
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
  })();

  // nonparticipating capturing group, copied from es5-shim's String#split patch.
  var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

  var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

  if (PATCH) {
    patchedExec = function exec(str) {
      var re = this;
      var lastIndex, reCopy, match, i;

      if (NPCG_INCLUDED) {
        reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
      }
      if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

      match = nativeExec.call(re, str);

      if (UPDATES_LAST_INDEX_WRONG && match) {
        re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
      }
      if (NPCG_INCLUDED && match && match.length > 1) {
        // Fix browsers whose `exec` methods don't consistently return `undefined`
        // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
        nativeReplace.call(match[0], reCopy, function () {
          for (i = 1; i < arguments.length - 2; i++) {
            if (arguments[i] === undefined) match[i] = undefined;
          }
        });
      }

      return match;
    };
  }

  var regexpExec = patchedExec;

  _export({ target: 'RegExp', proto: true, forced: /./.exec !== regexpExec }, {
    exec: regexpExec
  });

  var MATCH = wellKnownSymbol('match');

  // `IsRegExp` abstract operation
  // https://tc39.github.io/ecma262/#sec-isregexp
  var isRegexp = function (it) {
    var isRegExp;
    return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
  };

  var SPECIES$2 = wellKnownSymbol('species');

  // `SpeciesConstructor` abstract operation
  // https://tc39.github.io/ecma262/#sec-speciesconstructor
  var speciesConstructor = function (O, defaultConstructor) {
    var C = anObject(O).constructor;
    var S;
    return C === undefined || (S = anObject(C)[SPECIES$2]) == undefined ? defaultConstructor : aFunction(S);
  };

  // CONVERT_TO_STRING: true  -> String#at
  // CONVERT_TO_STRING: false -> String#codePointAt
  var stringAt = function (that, pos, CONVERT_TO_STRING) {
    var S = String(requireObjectCoercible(that));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };

  // `AdvanceStringIndex` abstract operation
  // https://tc39.github.io/ecma262/#sec-advancestringindex
  var advanceStringIndex = function (S, index, unicode) {
    return index + (unicode ? stringAt(S, index, true).length : 1);
  };

  // `RegExpExec` abstract operation
  // https://tc39.github.io/ecma262/#sec-regexpexec
  var regexpExecAbstract = function (R, S) {
    var exec = R.exec;
    if (typeof exec === 'function') {
      var result = exec.call(R, S);
      if (typeof result !== 'object') {
        throw TypeError('RegExp exec method returned something other than an Object or null');
      }
      return result;
    }

    if (classofRaw(R) !== 'RegExp') {
      throw TypeError('RegExp#exec called on incompatible receiver');
    }

    return regexpExec.call(R, S);
  };

  var SPECIES$3 = wellKnownSymbol('species');

  var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
    // #replace needs built-in support for named groups.
    // #match works fine because it just return the exec results, even if it has
    // a "grops" property.
    var re = /./;
    re.exec = function () {
      var result = [];
      result.groups = { a: '7' };
      return result;
    };
    return ''.replace(re, '$<a>') !== '7';
  });

  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  // Weex JS has frozen built-in prototypes, so use try / catch wrapper
  var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function () { return originalExec.apply(this, arguments); };
    var result = 'ab'.split(re);
    return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
  });

  var fixRegexpWellKnownSymbolLogic = function (KEY, length, exec, sham) {
    var SYMBOL = wellKnownSymbol(KEY);

    var DELEGATES_TO_SYMBOL = !fails(function () {
      // String methods call symbol-named RegEp methods
      var O = {};
      O[SYMBOL] = function () { return 7; };
      return ''[KEY](O) != 7;
    });

    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
      // Symbol-named RegExp methods call .exec
      var execCalled = false;
      var re = /a/;
      re.exec = function () { execCalled = true; return null; };

      if (KEY === 'split') {
        // RegExp[@@split] doesn't call the regex's exec method, but first creates
        // a new one. We need to return the patched regex when creating the new one.
        re.constructor = {};
        re.constructor[SPECIES$3] = function () { return re; };
      }

      re[SYMBOL]('');
      return !execCalled;
    });

    if (
      !DELEGATES_TO_SYMBOL ||
      !DELEGATES_TO_EXEC ||
      (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
      (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
    ) {
      var nativeRegExpMethod = /./[SYMBOL];
      var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      });
      var stringMethod = methods[0];
      var regexMethod = methods[1];

      redefine(String.prototype, KEY, stringMethod);
      redefine(RegExp.prototype, SYMBOL, length == 2
        // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
        // 21.2.5.11 RegExp.prototype[@@split](string, limit)
        ? function (string, arg) { return regexMethod.call(string, this, arg); }
        // 21.2.5.6 RegExp.prototype[@@match](string)
        // 21.2.5.9 RegExp.prototype[@@search](string)
        : function (string) { return regexMethod.call(string, this); }
      );
      if (sham) hide(RegExp.prototype[SYMBOL], 'sham', true);
    }
  };

  var arrayPush = [].push;
  var min$2 = Math.min;
  var MAX_UINT32 = 0xFFFFFFFF;

  // babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
  var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

  // @@split logic
  fixRegexpWellKnownSymbolLogic(
    'split',
    2,
    function (SPLIT, nativeSplit, maybeCallNative) {
      var internalSplit;
      if (
        'abbc'.split(/(b)*/)[1] == 'c' ||
        'test'.split(/(?:)/, -1).length != 4 ||
        'ab'.split(/(?:ab)*/).length != 2 ||
        '.'.split(/(.?)(.?)/).length != 4 ||
        '.'.split(/()()/).length > 1 ||
        ''.split(/.?/).length
      ) {
        // based on es5-shim implementation, need to rework it
        internalSplit = function (separator, limit) {
          var string = String(requireObjectCoercible(this));
          var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
          if (lim === 0) return [];
          if (separator === undefined) return [string];
          // If `separator` is not a regex, use native split
          if (!isRegexp(separator)) {
            return nativeSplit.call(string, separator, lim);
          }
          var output = [];
          var flags = (separator.ignoreCase ? 'i' : '') +
                      (separator.multiline ? 'm' : '') +
                      (separator.unicode ? 'u' : '') +
                      (separator.sticky ? 'y' : '');
          var lastLastIndex = 0;
          // Make `global` and avoid `lastIndex` issues by working with a copy
          var separatorCopy = new RegExp(separator.source, flags + 'g');
          var match, lastIndex, lastLength;
          while (match = regexpExec.call(separatorCopy, string)) {
            lastIndex = separatorCopy.lastIndex;
            if (lastIndex > lastLastIndex) {
              output.push(string.slice(lastLastIndex, match.index));
              if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
              lastLength = match[0].length;
              lastLastIndex = lastIndex;
              if (output.length >= lim) break;
            }
            if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
          }
          if (lastLastIndex === string.length) {
            if (lastLength || !separatorCopy.test('')) output.push('');
          } else output.push(string.slice(lastLastIndex));
          return output.length > lim ? output.slice(0, lim) : output;
        };
      // Chakra, V8
      } else if ('0'.split(undefined, 0).length) {
        internalSplit = function (separator, limit) {
          return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
        };
      } else internalSplit = nativeSplit;

      return [
        // `String.prototype.split` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
          var O = requireObjectCoercible(this);
          var splitter = separator == undefined ? undefined : separator[SPLIT];
          return splitter !== undefined
            ? splitter.call(separator, O, limit)
            : internalSplit.call(String(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function (regexp, limit) {
          var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
          if (res.done) return res.value;

          var rx = anObject(regexp);
          var S = String(this);
          var C = speciesConstructor(rx, RegExp);

          var unicodeMatching = rx.unicode;
          var flags = (rx.ignoreCase ? 'i' : '') +
                      (rx.multiline ? 'm' : '') +
                      (rx.unicode ? 'u' : '') +
                      (SUPPORTS_Y ? 'y' : 'g');

          // ^(? + rx + ) is needed, in combination with some S slicing, to
          // simulate the 'y' flag.
          var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
          var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
          if (lim === 0) return [];
          if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
          var p = 0;
          var q = 0;
          var A = [];
          while (q < S.length) {
            splitter.lastIndex = SUPPORTS_Y ? q : 0;
            var z = regexpExecAbstract(splitter, SUPPORTS_Y ? S : S.slice(q));
            var e;
            if (
              z === null ||
              (e = min$2(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
            ) {
              q = advanceStringIndex(S, q, unicodeMatching);
            } else {
              A.push(S.slice(p, q));
              if (A.length === lim) return A;
              for (var i = 1; i <= z.length - 1; i++) {
                A.push(z[i]);
                if (A.length === lim) return A;
              }
              q = p = e;
            }
          }
          A.push(S.slice(p));
          return A;
        }
      ];
    },
    !SUPPORTS_Y
  );

  var TemplateTag_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  var _templateObject = _taggedTemplateLiteral(['', ''], ['', '']);

  function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  /**
   * @class TemplateTag
   * @classdesc Consumes a pipeline of composable transformer plugins and produces a template tag.
   */
  var TemplateTag = function () {
    /**
     * constructs a template tag
     * @constructs TemplateTag
     * @param  {...Object} [...transformers] - an array or arguments list of transformers
     * @return {Function}                    - a template tag
     */
    function TemplateTag() {
      var _this = this;

      for (var _len = arguments.length, transformers = Array(_len), _key = 0; _key < _len; _key++) {
        transformers[_key] = arguments[_key];
      }

      _classCallCheck(this, TemplateTag);

      this.tag = function (strings) {
        for (var _len2 = arguments.length, expressions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          expressions[_key2 - 1] = arguments[_key2];
        }

        if (typeof strings === 'function') {
          // if the first argument passed is a function, assume it is a template tag and return
          // an intermediary tag that processes the template using the aforementioned tag, passing the
          // result to our tag
          return _this.interimTag.bind(_this, strings);
        }

        if (typeof strings === 'string') {
          // if the first argument passed is a string, just transform it
          return _this.transformEndResult(strings);
        }

        // else, return a transformed end result of processing the template with our tag
        strings = strings.map(_this.transformString.bind(_this));
        return _this.transformEndResult(strings.reduce(_this.processSubstitutions.bind(_this, expressions)));
      };

      // if first argument is an array, extrude it as a list of transformers
      if (transformers.length > 0 && Array.isArray(transformers[0])) {
        transformers = transformers[0];
      }

      // if any transformers are functions, this means they are not initiated - automatically initiate them
      this.transformers = transformers.map(function (transformer) {
        return typeof transformer === 'function' ? transformer() : transformer;
      });

      // return an ES2015 template tag
      return this.tag;
    }

    /**
     * Applies all transformers to a template literal tagged with this method.
     * If a function is passed as the first argument, assumes the function is a template tag
     * and applies it to the template, returning a template tag.
     * @param  {(Function|String|Array<String>)} strings        - Either a template tag or an array containing template strings separated by identifier
     * @param  {...*}                            ...expressions - Optional list of substitution values.
     * @return {(String|Function)}                              - Either an intermediary tag function or the results of processing the template.
     */


    _createClass(TemplateTag, [{
      key: 'interimTag',


      /**
       * An intermediary template tag that receives a template tag and passes the result of calling the template with the received
       * template tag to our own template tag.
       * @param  {Function}        nextTag          - the received template tag
       * @param  {Array<String>}   template         - the template to process
       * @param  {...*}            ...substitutions - `substitutions` is an array of all substitutions in the template
       * @return {*}                                - the final processed value
       */
      value: function interimTag(previousTag, template) {
        for (var _len3 = arguments.length, substitutions = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
          substitutions[_key3 - 2] = arguments[_key3];
        }

        return this.tag(_templateObject, previousTag.apply(undefined, [template].concat(substitutions)));
      }

      /**
       * Performs bulk processing on the tagged template, transforming each substitution and then
       * concatenating the resulting values into a string.
       * @param  {Array<*>} substitutions - an array of all remaining substitutions present in this template
       * @param  {String}   resultSoFar   - this iteration's result string so far
       * @param  {String}   remainingPart - the template chunk after the current substitution
       * @return {String}                 - the result of joining this iteration's processed substitution with the result
       */

    }, {
      key: 'processSubstitutions',
      value: function processSubstitutions(substitutions, resultSoFar, remainingPart) {
        var substitution = this.transformSubstitution(substitutions.shift(), resultSoFar);
        return ''.concat(resultSoFar, substitution, remainingPart);
      }

      /**
       * Iterate through each transformer, applying the transformer's `onString` method to the template
       * strings before all substitutions are processed.
       * @param {String}  str - The input string
       * @return {String}     - The final results of processing each transformer
       */

    }, {
      key: 'transformString',
      value: function transformString(str) {
        var cb = function cb(res, transform) {
          return transform.onString ? transform.onString(res) : res;
        };
        return this.transformers.reduce(cb, str);
      }

      /**
       * When a substitution is encountered, iterates through each transformer and applies the transformer's
       * `onSubstitution` method to the substitution.
       * @param  {*}      substitution - The current substitution
       * @param  {String} resultSoFar  - The result up to and excluding this substitution.
       * @return {*}                   - The final result of applying all substitution transformations.
       */

    }, {
      key: 'transformSubstitution',
      value: function transformSubstitution(substitution, resultSoFar) {
        var cb = function cb(res, transform) {
          return transform.onSubstitution ? transform.onSubstitution(res, resultSoFar) : res;
        };
        return this.transformers.reduce(cb, substitution);
      }

      /**
       * Iterates through each transformer, applying the transformer's `onEndResult` method to the
       * template literal after all substitutions have finished processing.
       * @param  {String} endResult - The processed template, just before it is returned from the tag
       * @return {String}           - The final results of processing each transformer
       */

    }, {
      key: 'transformEndResult',
      value: function transformEndResult(endResult) {
        var cb = function cb(res, transform) {
          return transform.onEndResult ? transform.onEndResult(res) : res;
        };
        return this.transformers.reduce(cb, endResult);
      }
    }]);

    return TemplateTag;
  }();

  exports.default = TemplateTag;
  module.exports = exports['default'];

  });

  unwrapExports(TemplateTag_1);

  var TemplateTag = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = undefined;



  var _TemplateTag2 = _interopRequireDefault(TemplateTag_1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = _TemplateTag2.default;
  module.exports = exports['default'];

  });

  unwrapExports(TemplateTag);

  var stripIndentTransformer_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

  /**
   * strips indentation from a template literal
   * @param  {String} type = 'initial' - whether to remove all indentation or just leading indentation. can be 'all' or 'initial'
   * @return {Object}                  - a TemplateTag transformer
   */
  var stripIndentTransformer = function stripIndentTransformer() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'initial';
    return {
      onEndResult: function onEndResult(endResult) {
        if (type === 'initial') {
          // remove the shortest leading indentation from each line
          var match = endResult.match(/^[^\S\n]*(?=\S)/gm);
          var indent = match && Math.min.apply(Math, _toConsumableArray(match.map(function (el) {
            return el.length;
          })));
          if (indent) {
            var regexp = new RegExp('^.{' + indent + '}', 'gm');
            return endResult.replace(regexp, '');
          }
          return endResult;
        }
        if (type === 'all') {
          // remove all indentation from each line
          return endResult.replace(/^[^\S\n]+/gm, '');
        }
        throw new Error('Unknown type: ' + type);
      }
    };
  };

  exports.default = stripIndentTransformer;
  module.exports = exports['default'];

  });

  unwrapExports(stripIndentTransformer_1);

  var stripIndentTransformer = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = undefined;



  var _stripIndentTransformer2 = _interopRequireDefault(stripIndentTransformer_1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = _stripIndentTransformer2.default;
  module.exports = exports['default'];

  });

  unwrapExports(stripIndentTransformer);

  var trimResultTransformer_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * TemplateTag transformer that trims whitespace on the end result of a tagged template
   * @param  {String} side = '' - The side of the string to trim. Can be 'start' or 'end' (alternatively 'left' or 'right')
   * @return {Object}           - a TemplateTag transformer
   */
  var trimResultTransformer = function trimResultTransformer() {
    var side = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return {
      onEndResult: function onEndResult(endResult) {
        if (side === '') {
          return endResult.trim();
        }

        side = side.toLowerCase();

        if (side === 'start' || side === 'left') {
          return endResult.replace(/^\s*/, '');
        }

        if (side === 'end' || side === 'right') {
          return endResult.replace(/\s*$/, '');
        }

        throw new Error('Side not supported: ' + side);
      }
    };
  };

  exports.default = trimResultTransformer;
  module.exports = exports['default'];

  });

  unwrapExports(trimResultTransformer_1);

  var trimResultTransformer = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = undefined;



  var _trimResultTransformer2 = _interopRequireDefault(trimResultTransformer_1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = _trimResultTransformer2.default;
  module.exports = exports['default'];

  });

  unwrapExports(trimResultTransformer);

  var stripIndents_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });



  var _TemplateTag2 = _interopRequireDefault(TemplateTag);



  var _stripIndentTransformer2 = _interopRequireDefault(stripIndentTransformer);



  var _trimResultTransformer2 = _interopRequireDefault(trimResultTransformer);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  var stripIndents = new _TemplateTag2.default((0, _stripIndentTransformer2.default)('all'), _trimResultTransformer2.default);

  exports.default = stripIndents;
  module.exports = exports['default'];

  });

  unwrapExports(stripIndents_1);

  var stripIndents = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = undefined;



  var _stripIndents2 = _interopRequireDefault(stripIndents_1);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  exports.default = _stripIndents2.default;
  module.exports = exports['default'];

  });

  var stripIndents$1 = unwrapExports(stripIndents);

  /**
   * @description A function used to construct the value of a given matrix location.
   *
   * @callback MatrixConstructor
   * @param {Location} location - The location of the constructed value.
   *
   * @returns {Object} The value to be created at this location
   */

  /**
   * @description Creates a matrix of the specified dimensions where each location is filled with the
   * result of running the constructor function.
   *
   * @param {MatrixConstructor} constructor - The function used to construct each value of the array.
   * @param {Dimensions} dimensions - The length of the array to be filled.
   * @returns {Object[][]} Newly created matrix of the constructed values.
   */

  var constructMatrix = ramda.curry(function (constructor, dimensions) {
    return ramda.pipe(initMatrix, mapMatrix(function (_, location) {
      return constructor(location);
    }))(dimensions);
  });
  /**
   * @description A function used to construct the value of a given matrix location
   * based on an input character.
   *
   * @callback MatrixCharacterMap
   * @param {string} character - Character for the current location
   * @param {Location} location - The location of the constructed value.
   * @param {Object[][]} - the entire template matrix
   *
   * @returns {Object} The value to be created at this location
   */

  /**
   * @description Constructs a matrix from a template string. The template string should
   * represent the matrix. Each line of the template string (separated by newlines)
   * represents a row in the matrix. On each line (or row), a column is indicated by a
   * space between characters.
   *
   * @example This template string would create a 3x3 matrix with a different value for
   * the center cell. The mapCharacter function could initialize different data based on
   * this character.
   * . . .
   * . x .
   * . . .
   *
   * @param {MatrixCharacterMap} mapCharacter - function to construct each location based
   * on the character map
   * @param {string} template - a two dimensional string representing the matrix to be created
   *
   * @returns {Object[][]} Newly created matrix of the constructed values.
   */

  var constructMatrixFromTemplate = ramda.curry(function (mapCharacter, template) {
    var stripped = stripIndents$1(template);
    var rows = stripped.split("\n");
    var templateMatrix = rows.map(function (row) {
      return row.split(" ");
    });
    return mapMatrix(function (_char, location) {
      return mapCharacter(_char, location, templateMatrix);
    })(templateMatrix);
  });

  /**
   * @module Matrix
   */

  /**
   * @description Returns an array of all locations connected to
   * the starting open locations. Connections defined by getNeighbors
   * and isLocationValid functions.
   *
   * @param {getNeighbors} getNeighbors
   * @param {CellComparator} isLocationValid
   * @param {Object[][]} matrix
   * @param {Location[]} open - locations to start floodfilling from
   * @param {Location[]} closed - usually empty, locations here will not
   * be checked by the floodfill algorithm.
   * @param {Location[]} found - usually empty, locations here will be
   * returned by the floodfill function. If this array contains locations
   * that the algorithm will find on its own, these values will be
   * duplicated. This function does not guarantee uniqueness in that case.
   *
   * @returns {Location[]} flooded locations
   */

  var floodFill = function floodFill(getNeighbors, isLocationValid, matrix, open, closed, found) {
    if (open.length === 0) {
      // exit case, we've found all connected locations
      return found;
    } // get next open location


    var location = open.pop();

    if (isLocationValid(getLocation(matrix, location), location, matrix)) {
      // mark location as found
      found.push(location); // add all the neighbors

      var neighbors = getNeighbors(matrix, location);
      neighbors.forEach(function (neighbor) {
        if (!containsLocation(closed, neighbor) && !containsLocation(open, neighbor)) {
          // if location not already closed or open, push it into open
          open.push(neighbor);
        }
      });
    } // close current location


    closed.push(location);
    return floodFill(getNeighbors, isLocationValid, matrix, open, closed, found);
  };

  var max$1 = Math.max;
  var min$3 = Math.min;
  var MAX_SAFE_INTEGER$1 = 0x1FFFFFFFFFFFFF;
  var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

  var SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport('splice');

  // `Array.prototype.splice` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.splice
  // with adding support of @@species
  _export({ target: 'Array', proto: true, forced: !SPECIES_SUPPORT$3 }, {
    splice: function splice(start, deleteCount /* , ...items */) {
      var O = toObject(this);
      var len = toLength(O.length);
      var actualStart = toAbsoluteIndex(start, len);
      var argumentsLength = arguments.length;
      var insertCount, actualDeleteCount, A, k, from, to;
      if (argumentsLength === 0) {
        insertCount = actualDeleteCount = 0;
      } else if (argumentsLength === 1) {
        insertCount = 0;
        actualDeleteCount = len - actualStart;
      } else {
        insertCount = argumentsLength - 2;
        actualDeleteCount = min$3(max$1(toInteger(deleteCount), 0), len - actualStart);
      }
      if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER$1) {
        throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
      }
      A = arraySpeciesCreate(O, actualDeleteCount);
      for (k = 0; k < actualDeleteCount; k++) {
        from = actualStart + k;
        if (from in O) createProperty(A, k, O[from]);
      }
      A.length = actualDeleteCount;
      if (insertCount < actualDeleteCount) {
        for (k = actualStart; k < len - actualDeleteCount; k++) {
          from = k + actualDeleteCount;
          to = k + insertCount;
          if (from in O) O[to] = O[from];
          else delete O[to];
        }
        for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
      } else if (insertCount > actualDeleteCount) {
        for (k = len - actualDeleteCount; k > actualStart; k--) {
          from = k + actualDeleteCount - 1;
          to = k + insertCount - 1;
          if (from in O) O[to] = O[from];
          else delete O[to];
        }
      }
      for (k = 0; k < insertCount; k++) {
        O[k + actualStart] = arguments[k + 2];
      }
      O.length = len - actualDeleteCount + insertCount;
      return A;
    }
  });

  var findPath = function findPath(trackingMatrix, location) {
    var _getLocation = getLocation(trackingMatrix, location),
        parent = _getLocation.parent;

    if (!parent) {
      return [location];
    }

    return [].concat(_toConsumableArray(findPath(trackingMatrix, parent)), [location]);
  };

  var createTrackingMatrix = function createTrackingMatrix(matrix, start, target, heuristicFn) {
    var dimensions = getDimensions(matrix);
    var trackingMatrix = constructMatrix(function () {
      return {
        heuristicDistance: Infinity,
        distanceFromStart: Infinity
      };
    })(dimensions);
    var trackingMatrixWithStartMarked = updateMatrix(start, {
      heuristicDistance: heuristicFn(start, target),
      distanceFromStart: 0,
      parent: null
    }, trackingMatrix);
    return trackingMatrixWithStartMarked;
  };
  /*
   *
   *
   * A-Star Adaptation based on:
   * https://briangrinstead.com/blog/astar-search-algorithm-in-javascript/
   *
   * @param {*} getNeighbors
   * @param {*} isLocationValid
   * @param {*} matrix
   * @param {*} trackingMatrix
   * @param {*} target
   * @param {*} open
   * @param {*} closed
   * @param {*} distance
   * @param {*} heuristicFn
   */


  var createPath = function createPath(getNeighbors, isLocationValid, matrix, trackingMatrix, target, open, closed, heuristicFn) {
    if (open.length === 0) {
      // exit case, could not find target
      return undefined;
    }

    var updatedTrackingMatrix = ramda.clone(trackingMatrix); // get next open location nearest to current location

    var locationIndex = findBestMatch(function (openLocation) {
      var _getLocation2 = getLocation(trackingMatrix, openLocation),
          heuristicDistance = _getLocation2.heuristicDistance,
          distanceFromStart = _getLocation2.distanceFromStart;

      return heuristicDistance + distanceFromStart;
    }, // find location with shortest distance from start + expected distance (heuristic)
    function (currentBest, evaluated) {
      if (evaluated < currentBest) {
        return true;
      }

      return false;
    }, open); // remove found location from open list

    var _open$splice = open.splice(locationIndex, 1),
        _open$splice2 = _slicedToArray(_open$splice, 1),
        location = _open$splice2[0]; // console.log("location -- ", location, open, trackingMatrix);


    if (isLocationValid(getLocation(matrix, location), location, matrix)) {
      // record our distance somehow
      if (compareLocations(location, target)) {
        // exit case, we found our destination, return the end of our path
        return findPath(trackingMatrix, location);
      } // open all the neighbors


      var neighbors = getNeighbors(matrix, location);
      neighbors.forEach(function (neighbor) {
        if (!containsLocation(closed, neighbor)) {
          var isNewDistanceShortest = false;
          var neighborHeuristicDistance = heuristicFn(neighbor, target);
          var neighborDistanceFromStart = getLocation(trackingMatrix, location).distanceFromStart + 1;

          if (!containsLocation(open, neighbor)) {
            // no other distance tracked for this neighbor, it must be shortest
            isNewDistanceShortest = true; // if location not already closed or open, push it into open

            open.push(neighbor);
          } // is neighbor's tracked distanceFromStart worse than the one we just calcuated?


          if (neighborDistanceFromStart < getLocation(trackingMatrix, neighbor).distanceFromStart) {
            // we have found a shorter path to our neighbor
            isNewDistanceShortest = true;
          }

          if (isNewDistanceShortest) {
            // updateTracking data
            updatedTrackingMatrix = updateMatrix(neighbor, {
              heuristicDistance: neighborHeuristicDistance,
              distanceFromStart: neighborDistanceFromStart,
              parent: location
            }, updatedTrackingMatrix);
          }
        }
      });
    } // close this location so we don't evaluate it again


    closed.push(location); // evaluate next location

    var path = createPath(getNeighbors, isLocationValid, matrix, updatedTrackingMatrix, target, open, closed, heuristicFn); // a path was found to target node, add our current location as a member of the path

    if (path) {
      return path;
    } // there is no path to the target along this node


    return undefined;
  };
  /**
   * @description Find the path from a start location to a target location
   * using the specified matrix and parameters.
   *
   * @param {getNeighbors} getNeighbors
   * @param {CellComparator} isLocationValid
   * @param {Objet[][]} matrix
   * @param {Location} start
   * @param {Location} target
   *
   * @returns {Location[]} array of locations leading from the start location
   * to the target location, including the start and target locations on either
   * end of the array.
   */


  var getPath = ramda.curry(function (getNeighbors, isLocationValid, matrix, start, target) {
    var heuristicFn = manhattanDistance;
    var trackingMatrix = createTrackingMatrix(matrix, start, target, heuristicFn);
    return createPath(getNeighbors, isLocationValid, matrix, trackingMatrix, target, [start], [], heuristicFn);
  });

  var internalSome = arrayMethods(3);

  var SLOPPY_METHOD$2 = sloppyArrayMethod('some');

  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  _export({ target: 'Array', proto: true, forced: SLOPPY_METHOD$2 }, {
    some: function some(callbackfn /* , thisArg */) {
      return internalSome(this, callbackfn, arguments[1]);
    }
  });

  var defineProperty = objectDefineProperty.f;

  var TO_STRING_TAG = wellKnownSymbol('toStringTag');

  var setToStringTag = function (it, TAG, STATIC) {
    if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
      defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
    }
  };

  var f$5 = wellKnownSymbol;

  var wrappedWellKnownSymbol = {
  	f: f$5
  };

  var path = global;

  var defineProperty$1 = objectDefineProperty.f;

  var defineWellKnownSymbol = function (NAME) {
    var Symbol = path.Symbol || (path.Symbol = {});
    if (!has(Symbol, NAME)) defineProperty$1(Symbol, NAME, {
      value: wrappedWellKnownSymbol.f(NAME)
    });
  };

  // all enumerable object keys, includes symbols
  var enumKeys = function (it) {
    var result = objectKeys(it);
    var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
    if (getOwnPropertySymbols) {
      var symbols = getOwnPropertySymbols(it);
      var propertyIsEnumerable = objectPropertyIsEnumerable.f;
      var i = 0;
      var key;
      while (symbols.length > i) if (propertyIsEnumerable.call(it, key = symbols[i++])) result.push(key);
    } return result;
  };

  // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

  var nativeGetOwnPropertyNames = objectGetOwnPropertyNames.f;
  var toString$1 = {}.toString;

  var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
    ? Object.getOwnPropertyNames(window) : [];

  var getWindowNames = function (it) {
    try {
      return nativeGetOwnPropertyNames(it);
    } catch (error) {
      return windowNames.slice();
    }
  };

  var f$6 = function getOwnPropertyNames(it) {
    return windowNames && toString$1.call(it) == '[object Window]'
      ? getWindowNames(it)
      : nativeGetOwnPropertyNames(toIndexedObject(it));
  };

  var objectGetOwnPropertyNamesExternal = {
  	f: f$6
  };

  // ECMAScript 6 symbols shim




























  var HIDDEN = sharedKey('hidden');

  var SYMBOL = 'Symbol';
  var setInternalState = internalState.set;
  var getInternalState = internalState.getterFor(SYMBOL);
  var nativeGetOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
  var nativeDefineProperty$1 = objectDefineProperty.f;
  var nativeGetOwnPropertyNames$1 = objectGetOwnPropertyNamesExternal.f;
  var $Symbol = global.Symbol;
  var JSON$1 = global.JSON;
  var nativeJSONStringify = JSON$1 && JSON$1.stringify;
  var PROTOTYPE$1 = 'prototype';
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
  var nativePropertyIsEnumerable$1 = objectPropertyIsEnumerable.f;
  var SymbolRegistry = shared('symbol-registry');
  var AllSymbols = shared('symbols');
  var ObjectPrototypeSymbols = shared('op-symbols');
  var WellKnownSymbolsStore = shared('wks');
  var ObjectPrototype = Object[PROTOTYPE$1];
  var QObject = global.QObject;

  // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
  var USE_SETTER = !QObject || !QObject[PROTOTYPE$1] || !QObject[PROTOTYPE$1].findChild;

  // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
  var setSymbolDescriptor = descriptors && fails(function () {
    return objectCreate(nativeDefineProperty$1({}, 'a', {
      get: function () { return nativeDefineProperty$1(this, 'a', { value: 7 }).a; }
    })).a != 7;
  }) ? function (it, key, D) {
    var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$2(ObjectPrototype, key);
    if (ObjectPrototypeDescriptor) delete ObjectPrototype[key];
    nativeDefineProperty$1(it, key, D);
    if (ObjectPrototypeDescriptor && it !== ObjectPrototype) {
      nativeDefineProperty$1(ObjectPrototype, key, ObjectPrototypeDescriptor);
    }
  } : nativeDefineProperty$1;

  var wrap = function (tag, description) {
    var symbol = AllSymbols[tag] = objectCreate($Symbol[PROTOTYPE$1]);
    setInternalState(symbol, {
      type: SYMBOL,
      tag: tag,
      description: description
    });
    if (!descriptors) symbol.description = description;
    return symbol;
  };

  var isSymbol = nativeSymbol && typeof $Symbol.iterator == 'symbol' ? function (it) {
    return typeof it == 'symbol';
  } : function (it) {
    return Object(it) instanceof $Symbol;
  };

  var $defineProperty = function defineProperty(it, key, D) {
    if (it === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, key, D);
    anObject(it);
    key = toPrimitive(key, true);
    anObject(D);
    if (has(AllSymbols, key)) {
      if (!D.enumerable) {
        if (!has(it, HIDDEN)) nativeDefineProperty$1(it, HIDDEN, createPropertyDescriptor(1, {}));
        it[HIDDEN][key] = true;
      } else {
        if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
        D = objectCreate(D, { enumerable: createPropertyDescriptor(0, false) });
      } return setSymbolDescriptor(it, key, D);
    } return nativeDefineProperty$1(it, key, D);
  };

  var $defineProperties = function defineProperties(it, P) {
    anObject(it);
    var keys = enumKeys(P = toIndexedObject(P));
    var i = 0;
    var l = keys.length;
    var key;
    while (l > i) $defineProperty(it, key = keys[i++], P[key]);
    return it;
  };

  var $create = function create(it, P) {
    return P === undefined ? objectCreate(it) : $defineProperties(objectCreate(it), P);
  };

  var $propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = nativePropertyIsEnumerable$1.call(this, key = toPrimitive(key, true));
    if (this === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return false;
    return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
  };

  var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = toIndexedObject(it);
    key = toPrimitive(key, true);
    if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
    var D = nativeGetOwnPropertyDescriptor$2(it, key);
    if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
    return D;
  };

  var $getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = nativeGetOwnPropertyNames$1(toIndexedObject(it));
    var result = [];
    var i = 0;
    var key;
    while (names.length > i) {
      if (!has(AllSymbols, key = names[i++]) && !has(hiddenKeys, key)) result.push(key);
    } return result;
  };

  var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === ObjectPrototype;
    var names = nativeGetOwnPropertyNames$1(IS_OP ? ObjectPrototypeSymbols : toIndexedObject(it));
    var result = [];
    var i = 0;
    var key;
    while (names.length > i) {
      if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectPrototype, key) : true)) result.push(AllSymbols[key]);
    } return result;
  };

  // `Symbol` constructor
  // https://tc39.github.io/ecma262/#sec-symbol-constructor
  if (!nativeSymbol) {
    $Symbol = function Symbol() {
      if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
      var description = arguments[0] === undefined ? undefined : String(arguments[0]);
      var tag = uid(description);
      var setter = function (value) {
        if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
        if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
        setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
      };
      if (descriptors && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
      return wrap(tag, description);
    };
    redefine($Symbol[PROTOTYPE$1], 'toString', function toString() {
      return getInternalState(this).tag;
    });

    objectPropertyIsEnumerable.f = $propertyIsEnumerable;
    objectDefineProperty.f = $defineProperty;
    objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor;
    objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames;
    objectGetOwnPropertySymbols.f = $getOwnPropertySymbols;

    if (descriptors) {
      // https://github.com/tc39/proposal-Symbol-description
      nativeDefineProperty$1($Symbol[PROTOTYPE$1], 'description', {
        configurable: true,
        get: function description() {
          return getInternalState(this).description;
        }
      });
      {
        redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
      }
    }

    wrappedWellKnownSymbol.f = function (name) {
      return wrap(wellKnownSymbol(name), name);
    };
  }

  _export({ global: true, wrap: true, forced: !nativeSymbol, sham: !nativeSymbol }, { Symbol: $Symbol });

  for (var wellKnownSymbols = objectKeys(WellKnownSymbolsStore), k = 0; wellKnownSymbols.length > k;) {
    defineWellKnownSymbol(wellKnownSymbols[k++]);
  }

  _export({ target: SYMBOL, stat: true, forced: !nativeSymbol }, {
    // `Symbol.for` method
    // https://tc39.github.io/ecma262/#sec-symbol.for
    'for': function (key) {
      return has(SymbolRegistry, key += '')
        ? SymbolRegistry[key]
        : SymbolRegistry[key] = $Symbol(key);
    },
    // `Symbol.keyFor` method
    // https://tc39.github.io/ecma262/#sec-symbol.keyfor
    keyFor: function keyFor(sym) {
      if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
      for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
    },
    useSetter: function () { USE_SETTER = true; },
    useSimple: function () { USE_SETTER = false; }
  });

  _export({ target: 'Object', stat: true, forced: !nativeSymbol, sham: !descriptors }, {
    // `Object.create` method
    // https://tc39.github.io/ecma262/#sec-object.create
    create: $create,
    // `Object.defineProperty` method
    // https://tc39.github.io/ecma262/#sec-object.defineproperty
    defineProperty: $defineProperty,
    // `Object.defineProperties` method
    // https://tc39.github.io/ecma262/#sec-object.defineproperties
    defineProperties: $defineProperties,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor
  });

  _export({ target: 'Object', stat: true, forced: !nativeSymbol }, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: $getOwnPropertyNames,
    // `Object.getOwnPropertySymbols` method
    // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
    getOwnPropertySymbols: $getOwnPropertySymbols
  });

  // `JSON.stringify` method behavior with symbols
  // https://tc39.github.io/ecma262/#sec-json.stringify
  JSON$1 && _export({ target: 'JSON', stat: true, forced: !nativeSymbol || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return nativeJSONStringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || nativeJSONStringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || nativeJSONStringify(Object(symbol)) != '{}';
  }) }, {
    stringify: function stringify(it) {
      var args = [it];
      var i = 1;
      var replacer, $replacer;
      while (arguments.length > i) args.push(arguments[i++]);
      $replacer = replacer = args[1];
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return nativeJSONStringify.apply(JSON$1, args);
    }
  });

  // `Symbol.prototype[@@toPrimitive]` method
  // https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
  if (!$Symbol[PROTOTYPE$1][TO_PRIMITIVE]) hide($Symbol[PROTOTYPE$1], TO_PRIMITIVE, $Symbol[PROTOTYPE$1].valueOf);
  // `Symbol.prototype[@@toStringTag]` property
  // https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
  setToStringTag($Symbol, SYMBOL);

  hiddenKeys[HIDDEN] = true;

  var defineProperty$2 = objectDefineProperty.f;

  var NativeSymbol = global.Symbol;

  if (descriptors && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
    // Safari 12 bug
    NativeSymbol().description !== undefined
  )) {
    var EmptyStringDescriptionStore = {};
    // wrap Symbol constructor for correct work with undefined description
    var SymbolWrapper = function Symbol() {
      var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
      var result = this instanceof SymbolWrapper
        ? new NativeSymbol(description)
        // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
        : description === undefined ? NativeSymbol() : NativeSymbol(description);
      if (description === '') EmptyStringDescriptionStore[result] = true;
      return result;
    };
    copyConstructorProperties(SymbolWrapper, NativeSymbol);
    var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
    symbolPrototype.constructor = SymbolWrapper;

    var symbolToString = symbolPrototype.toString;
    var native = String(NativeSymbol('test')) == 'Symbol(test)';
    var regexp = /^Symbol\((.*)\)[^)]+$/;
    defineProperty$2(symbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        var symbol = isObject(this) ? this.valueOf() : this;
        var string = symbolToString.call(symbol);
        if (has(EmptyStringDescriptionStore, symbol)) return '';
        var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
        return desc === '' ? undefined : desc;
      }
    });

    _export({ global: true, forced: true }, { Symbol: SymbolWrapper });
  }

  // `Symbol.iterator` well-known symbol
  // https://tc39.github.io/ecma262/#sec-symbol.iterator
  defineWellKnownSymbol('iterator');

  var correctPrototypeGetter = !fails(function () {
    function F() { /* empty */ }
    F.prototype.constructor = null;
    return Object.getPrototypeOf(new F()) !== F.prototype;
  });

  // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


  var IE_PROTO$1 = sharedKey('IE_PROTO');

  var ObjectPrototype$1 = Object.prototype;

  var objectGetPrototypeOf = correctPrototypeGetter ? Object.getPrototypeOf : function (O) {
    O = toObject(O);
    if (has(O, IE_PROTO$1)) return O[IE_PROTO$1];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) {
      return O.constructor.prototype;
    } return O instanceof Object ? ObjectPrototype$1 : null;
  };

  var ITERATOR = wellKnownSymbol('iterator');
  var BUGGY_SAFARI_ITERATORS = false;

  var returnThis = function () { return this; };

  // `%IteratorPrototype%` object
  // https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
  var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

  if ([].keys) {
    arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
    else {
      PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
      if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
    }
  }

  if (IteratorPrototype == undefined) IteratorPrototype = {};

  // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
  if (!has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);

  var iteratorsCore = {
    IteratorPrototype: IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
  };

  var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;

  var createIteratorConstructor = function (IteratorConstructor, NAME, next) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, { next: createPropertyDescriptor(1, next) });
    setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
    return IteratorConstructor;
  };

  var validateSetPrototypeOfArguments = function (O, proto) {
    anObject(O);
    if (!isObject(proto) && proto !== null) {
      throw TypeError("Can't set " + String(proto) + ' as a prototype');
    }
  };

  // Works with __proto__ only. Old v8 can't work with null proto objects.
  /* eslint-disable no-proto */


  var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
    var correctSetter = false;
    var test = {};
    var setter;
    try {
      setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
      setter.call(test, []);
      correctSetter = test instanceof Array;
    } catch (error) { /* empty */ }
    return function setPrototypeOf(O, proto) {
      validateSetPrototypeOfArguments(O, proto);
      if (correctSetter) setter.call(O, proto);
      else O.__proto__ = proto;
      return O;
    };
  }() : undefined);

  var ITERATOR$1 = wellKnownSymbol('iterator');


  var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
  var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
  var KEYS = 'keys';
  var VALUES = 'values';
  var ENTRIES = 'entries';

  var returnThis$1 = function () { return this; };

  var defineIterator = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    createIteratorConstructor(IteratorConstructor, NAME, next);

    var getIterationMethod = function (KIND) {
      if (KIND === DEFAULT && defaultIterator) return defaultIterator;
      if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];
      switch (KIND) {
        case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
        case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
        case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
      } return function () { return new IteratorConstructor(this); };
    };

    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[ITERATOR$1]
      || IterablePrototype['@@iterator']
      || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;

    // fix native
    if (anyNativeIterator) {
      CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
      if (IteratorPrototype$2 !== Object.prototype && CurrentIteratorPrototype.next) {
        if (objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$2) {
          if (objectSetPrototypeOf) {
            objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2);
          } else if (typeof CurrentIteratorPrototype[ITERATOR$1] != 'function') {
            hide(CurrentIteratorPrototype, ITERATOR$1, returnThis$1);
          }
        }
        // Set @@toStringTag to native iterators
        setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      }
    }

    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return nativeIterator.call(this); };
    }

    // define iterator
    if (IterablePrototype[ITERATOR$1] !== defaultIterator) {
      hide(IterablePrototype, ITERATOR$1, defaultIterator);
    }

    // export additional methods
    if (DEFAULT) {
      methods = {
        values: getIterationMethod(VALUES),
        keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
        entries: getIterationMethod(ENTRIES)
      };
      if (FORCED) for (KEY in methods) {
        if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
          redefine(IterablePrototype, KEY, methods[KEY]);
        }
      } else _export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME }, methods);
    }

    return methods;
  };

  var ARRAY_ITERATOR = 'Array Iterator';
  var setInternalState$1 = internalState.set;
  var getInternalState$1 = internalState.getterFor(ARRAY_ITERATOR);

  // `Array.prototype.entries` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.entries
  // `Array.prototype.keys` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.keys
  // `Array.prototype.values` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.values
  // `Array.prototype[@@iterator]` method
  // https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
  // `CreateArrayIterator` internal method
  // https://tc39.github.io/ecma262/#sec-createarrayiterator
  var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
    setInternalState$1(this, {
      type: ARRAY_ITERATOR,
      target: toIndexedObject(iterated), // target
      index: 0,                          // next index
      kind: kind                         // kind
    });
  // `%ArrayIteratorPrototype%.next` method
  // https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
  }, function () {
    var state = getInternalState$1(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
      state.target = undefined;
      return { value: undefined, done: true };
    }
    if (kind == 'keys') return { value: index, done: false };
    if (kind == 'values') return { value: target[index], done: false };
    return { value: [index, target[index]], done: false };
  }, 'values');

  // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
  addToUnscopables('keys');
  addToUnscopables('values');
  addToUnscopables('entries');

  var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
  // ES3 wrong here
  var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

  // fallback for IE11 Script Access Denied error
  var tryGet = function (it, key) {
    try {
      return it[key];
    } catch (error) { /* empty */ }
  };

  // getting tag from ES6+ `Object.prototype.toString`
  var classof = function (it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null'
      // @@toStringTag case
      : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == 'string' ? tag
      // builtinTag case
      : CORRECT_ARGUMENTS ? classofRaw(O)
      // ES3 arguments fallback
      : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
  };

  var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');
  var test = {};

  test[TO_STRING_TAG$2] = 'z';

  // `Object.prototype.toString` method implementation
  // https://tc39.github.io/ecma262/#sec-object.prototype.tostring
  var objectToString = String(test) !== '[object z]' ? function toString() {
    return '[object ' + classof(this) + ']';
  } : test.toString;

  var ObjectPrototype$2 = Object.prototype;

  // `Object.prototype.toString` method
  // https://tc39.github.io/ecma262/#sec-object.prototype.tostring
  if (objectToString !== ObjectPrototype$2.toString) {
    redefine(ObjectPrototype$2, 'toString', objectToString, { unsafe: true });
  }

  var STRING_ITERATOR = 'String Iterator';
  var setInternalState$2 = internalState.set;
  var getInternalState$2 = internalState.getterFor(STRING_ITERATOR);

  // `String.prototype[@@iterator]` method
  // https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
  defineIterator(String, 'String', function (iterated) {
    setInternalState$2(this, {
      type: STRING_ITERATOR,
      string: String(iterated),
      index: 0
    });
  // `%StringIteratorPrototype%.next` method
  // https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
  }, function next() {
    var state = getInternalState$2(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return { value: undefined, done: true };
    point = stringAt(string, index, true);
    state.index += point.length;
    return { value: point, done: false };
  });

  var ITERATOR$2 = wellKnownSymbol('iterator');
  var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
  var ArrayValues = es_array_iterator.values;

  for (var COLLECTION_NAME$1 in domIterables) {
    var Collection$1 = global[COLLECTION_NAME$1];
    var CollectionPrototype$1 = Collection$1 && Collection$1.prototype;
    if (CollectionPrototype$1) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype$1[ITERATOR$2] !== ArrayValues) try {
        hide(CollectionPrototype$1, ITERATOR$2, ArrayValues);
      } catch (error) {
        CollectionPrototype$1[ITERATOR$2] = ArrayValues;
      }
      if (!CollectionPrototype$1[TO_STRING_TAG$3]) hide(CollectionPrototype$1, TO_STRING_TAG$3, COLLECTION_NAME$1);
      if (domIterables[COLLECTION_NAME$1]) for (var METHOD_NAME in es_array_iterator) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype$1[METHOD_NAME] !== es_array_iterator[METHOD_NAME]) try {
          hide(CollectionPrototype$1, METHOD_NAME, es_array_iterator[METHOD_NAME]);
        } catch (error) {
          CollectionPrototype$1[METHOD_NAME] = es_array_iterator[METHOD_NAME];
        }
      }
    }
  }

  /**
   * @module Queue
   */

  /**
   *
   */
  var Queue = /*#__PURE__*/function () {
    function Queue() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      _classCallCheck(this, Queue);

      // spread items to create a new array if it is iterable
      this.items = items[Symbol.iterator] ? _toConsumableArray(items) : [items];
    }

    _createClass(Queue, [{
      key: "isEmpty",
      value: function isEmpty() {
        return this.items.length === 0;
      }
    }, {
      key: "enqueue",
      value: function enqueue(item) {
        this.items.push(item);
      }
    }, {
      key: "dequeue",
      value: function dequeue() {
        return this.items.shift();
      }
    }]);

    return Queue;
  }();

  var internalFindIndex = arrayMethods(6);
  var FIND_INDEX = 'findIndex';
  var SKIPS_HOLES$1 = true;

  // Shouldn't skip holes
  if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES$1 = false; });

  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findindex
  _export({ target: 'Array', proto: true, forced: SKIPS_HOLES$1 }, {
    findIndex: function findIndex(callbackfn /* , that = undefined */) {
      return internalFindIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });

  // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
  addToUnscopables(FIND_INDEX);

  /**
   * @module Set
   */

  /**
   *
   */
  var ComparableSet = /*#__PURE__*/function () {
    function ComparableSet() {
      var comparator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (a, b) {
        return a === b;
      };

      _classCallCheck(this, ComparableSet);

      this.items = [];
      this.comparator = comparator;
    }

    _createClass(ComparableSet, [{
      key: "add",
      value: function add(item) {
        if (this.contains(item)) {
          return;
        }

        this.items.push(item);
      }
    }, {
      key: "contains",
      value: function contains(item) {
        var _this = this;

        return this.items.some(function (exisiting) {
          return _this.comparator(item, exisiting);
        });
      }
    }, {
      key: "remove",
      value: function remove(item) {
        var _this2 = this;

        var targetIndex = this.items.findIndex(function (exisiting) {
          return _this2.comparator(item, exisiting);
        });

        if (targetIndex === -1) {
          return undefined;
        }

        var _this$items$splice = this.items.splice(targetIndex, 1),
            _this$items$splice2 = _slicedToArray(_this$items$splice, 1),
            target = _this$items$splice2[0];

        return target;
      }
    }, {
      key: "size",
      get: function get() {
        return this.items.length;
      }
    }]);

    return ComparableSet;
  }();

  function createBaseMap(matrix, goals) {
    return mapMatrix(function (value, location) {
      if (goals.some(function (goal) {
        return compareLocations(goal, location);
      })) {
        return 0;
      }

      return Infinity;
    }, matrix);
  }
  /**
   * @description Creates a distance map with the given specifications. A
   * distance map is a matrix. Each call has an integer value. The value
   * is the manhattan distance that cell is from any goal location.
   *
   * AKA a "Djikstra Map" - http://www.roguebasin.com/index.php/Dijkstra_Maps_Visualized
   *
   * @param {getNeighbors} getNeighbors - function defining how to retrieve a
   * cell's neighbors
   * @param {CellComparator} isLocationValid - is a given cell able to be traversed.
   * Could be used to create walls or other impassable terrain.
   * @param {Object[][]} matrix
   * @param {Location[]} goals - array of target cells
   *
   * @returns {number[][]} - matrix containing the calculated distance map
   */


  function createDistanceMap(getNeighbors, isLocationValid, matrix, goals) {
    var distances = createBaseMap(matrix, goals);
    var cameFrom = initMatrix(getDimensions(matrix));
    var open = new Queue(goals);
    var closed = new ComparableSet(compareLocations); // close all goals so we don't revisit them

    goals.forEach(function (goal) {
      return closed.add(goal);
    });

    var _loop = function _loop() {
      var current = open.dequeue();
      var neighbors = getNeighbors(matrix, current);
      neighbors.forEach(function (neighbor) {
        if (!closed.contains(neighbor)) {
          closed.add(neighbor);

          if (isLocationValid(getLocation(matrix, neighbor), neighbor, matrix)) {
            open.enqueue(neighbor);
            cameFrom = updateMatrix(neighbor, current, cameFrom);
            var distance = getLocation(distances, current) + 1; // if another path is a shorter distance, use that instead

            if (distance < getLocation(distances, neighbor)) {
              distances = updateMatrix(neighbor, distance, distances);
            }
          }
        }
      });
    };

    while (!open.isEmpty()) {
      _loop();
    }

    return distances;
  }

  /**
   * @module Pathfinding
   */

  /**
   * @module Util
   */
  /**
   *
   */

  var trace = ramda.curry(function (msg, x) {
    return console.log(msg, x), x;
  });

  var DatePrototype = Date.prototype;
  var INVALID_DATE = 'Invalid Date';
  var TO_STRING = 'toString';
  var nativeDateToString = DatePrototype[TO_STRING];
  var getTime = DatePrototype.getTime;

  // `Date.prototype.toString` method
  // https://tc39.github.io/ecma262/#sec-date.prototype.tostring
  if (new Date(NaN) + '' != INVALID_DATE) {
    redefine(DatePrototype, TO_STRING, function toString() {
      var value = getTime.call(this);
      // eslint-disable-next-line no-self-compare
      return value === value ? nativeDateToString.call(this) : INVALID_DATE;
    });
  }

  var TO_STRING$1 = 'toString';
  var nativeToString = /./[TO_STRING$1];

  var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
  // FF44- RegExp#toString has a wrong name
  var INCORRECT_NAME = nativeToString.name != TO_STRING$1;

  // `RegExp.prototype.toString` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
  if (NOT_GENERIC || INCORRECT_NAME) {
    redefine(RegExp.prototype, TO_STRING$1, function toString() {
      var R = anObject(this);
      return '/'.concat(R.source, '/',
        'flags' in R ? R.flags : !descriptors && R instanceof RegExp ? regexpFlags.call(R) : undefined);
    }, { unsafe: true });
  }

  var max$2 = Math.max;
  var min$4 = Math.min;
  var floor$1 = Math.floor;
  var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
  var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

  var maybeToString = function (it) {
    return it === undefined ? it : String(it);
  };

  // @@replace logic
  fixRegexpWellKnownSymbolLogic(
    'replace',
    2,
    function (REPLACE, nativeReplace, maybeCallNative) {
      return [
        // `String.prototype.replace` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
          var O = requireObjectCoercible(this);
          var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
          return replacer !== undefined
            ? replacer.call(searchValue, O, replaceValue)
            : nativeReplace.call(String(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
        function (regexp, replaceValue) {
          var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
          if (res.done) return res.value;

          var rx = anObject(regexp);
          var S = String(this);

          var functionalReplace = typeof replaceValue === 'function';
          if (!functionalReplace) replaceValue = String(replaceValue);

          var global = rx.global;
          if (global) {
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
          }
          var results = [];
          while (true) {
            var result = regexpExecAbstract(rx, S);
            if (result === null) break;

            results.push(result);
            if (!global) break;

            var matchStr = String(result[0]);
            if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
          }

          var accumulatedResult = '';
          var nextSourcePosition = 0;
          for (var i = 0; i < results.length; i++) {
            result = results[i];

            var matched = String(result[0]);
            var position = max$2(min$4(toInteger(result.index), S.length), 0);
            var captures = [];
            // NOTE: This is equivalent to
            //   captures = result.slice(1).map(maybeToString)
            // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
            // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
            // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
            for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
            var namedCaptures = result.groups;
            if (functionalReplace) {
              var replacerArgs = [matched].concat(captures, position, S);
              if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
              var replacement = String(replaceValue.apply(undefined, replacerArgs));
            } else {
              replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
            }
            if (position >= nextSourcePosition) {
              accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
              nextSourcePosition = position + matched.length;
            }
          }
          return accumulatedResult + S.slice(nextSourcePosition);
        }
      ];

      // https://tc39.github.io/ecma262/#sec-getsubstitution
      function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
        var tailPos = position + matched.length;
        var m = captures.length;
        var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
        if (namedCaptures !== undefined) {
          namedCaptures = toObject(namedCaptures);
          symbols = SUBSTITUTION_SYMBOLS;
        }
        return nativeReplace.call(replacement, symbols, function (match, ch) {
          var capture;
          switch (ch.charAt(0)) {
            case '$': return '$';
            case '&': return matched;
            case '`': return str.slice(0, position);
            case "'": return str.slice(tailPos);
            case '<':
              capture = namedCaptures[ch.slice(1, -1)];
              break;
            default: // \d\d?
              var n = +ch;
              if (n === 0) return match;
              if (n > m) {
                var f = floor$1(n / 10);
                if (f === 0) return match;
                if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                return match;
              }
              capture = captures[n - 1];
          }
          return capture === undefined ? '' : capture;
        });
      }
    }
  );

  /**
   * @module Util
   */
  // https://gist.github.com/jed/982883

  /**
   *
   */
  function generateUuid(a // placeholder
  ) {
    return a // if the placeholder was passed, return
    ? // a random number from 0 to 15
    (a ^ // unless b is 8,
    Math.random() * // in which case
    16 >> // a random number from
    a / 4 // 8 to 11
    ).toString(16) // in hexadecimal
    : // or otherwise a concatenated string:
    ([1e7] + // 10000000 +
    -1e3 + // -1000 +
    -4e3 + // -4000 +
    -8e3 + // -80000000 +
    -1e11 // -100000000000,
    ).replace( // replacing
    /[018]/g, // zeroes, ones, and eights with
    generateUuid // random hex digits
    );
  }

  /**
   * @module Util
   */

  exports.AssertionError = AssertionError;
  exports.ComparableSet = ComparableSet;
  exports.MATRIX_ROTATION_DIRECTIONS = MATRIX_ROTATION_DIRECTIONS;
  exports.MATRIX_TRANSLATE_DIRECTIONS = MATRIX_TRANSLATE_DIRECTIONS;
  exports.Queue = Queue;
  exports.compareLocations = compareLocations;
  exports.constructArray = constructArray;
  exports.constructMatrix = constructMatrix;
  exports.constructMatrixFromTemplate = constructMatrixFromTemplate;
  exports.containsLocation = containsLocation;
  exports.createDistanceMap = createDistanceMap;
  exports.fillArray = fillArray;
  exports.fillMatrix = fillMatrix;
  exports.findBestMatch = findBestMatch;
  exports.findLocation = findLocation;
  exports.findLocations = findLocations;
  exports.findValue = findValue;
  exports.floodFill = floodFill;
  exports.generateUuid = generateUuid;
  exports.getAllDirections = getAllDirections;
  exports.getCol = getCol;
  exports.getConnectedDirections = getConnectedDirections;
  exports.getCrossDirections = getCrossDirections;
  exports.getDiagonalDirections = getDiagonalDirections;
  exports.getDimensions = getDimensions;
  exports.getLocation = getLocation;
  exports.getNeighbors = getNeighbors;
  exports.getPath = getPath;
  exports.getRow = getRow;
  exports.initArray = initArray;
  exports.initMatrix = initMatrix;
  exports.isLocationInBounds = isLocationInBounds;
  exports.manhattanDistance = manhattanDistance;
  exports.mapMatrix = mapMatrix;
  exports.rotateMatrix = rotateMatrix;
  exports.trace = trace;
  exports.translateMatrix = translateMatrix;
  exports.transposeMatrix = transposeMatrix;
  exports.updateMatrix = updateMatrix;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=functional-game-utils.js.map
